<div class="view-progress" [ngClass]="{'view-progress--active': show}" data-test="viewProgress">
  <div class="view-progress__circle" #circle [@isOpen]="show ? 'open' : 'closed'">
    <svg 
        class="view-progress__ring" 
        #progressContainer 
        [ngClass]="{
            'view-progress__ring--pulse': percent === 0 || percent === 100
        }">
      <circle #progressCircle class="view-progress__ring-inner"></circle>
    </svg>

    <div class="view-progress__count" *ngIf="percent > 0 && percent < 100">
      {{ percent }}%
    </div>
    <div class="view-progress__label">
      {{ label }}
    </div>
  </div>
</div>
